import { useCallback, useState } from "react"
import { Popper, PopperMenu, PopperMenuItem, PopperToggle } from "@gogoro/go-design"
import classnames from "classnames"
import { useLanguages } from "lang/languages"

import Icon from "components/Icon"

import styles from "./LanguageSelector.module.css"

const LanguageSelector = ({ actions }) => {
  const [isOpen, setIsOpen] = useState(false)

  const { languages, language } = useLanguages()

  const displayLang = languages.find((item) => item.code === language).name

  const toggle = useCallback(() => setIsOpen((state) => !state), [])

  return (
    <Popper isOpen={isOpen} toggle={toggle} placement="bottom">
      <PopperToggle>
        <div className={styles.container}>
          <span>{displayLang}</span>
          <Icon className={classnames(styles.icon, { [styles.isOpen]: isOpen })} icon="chevron-down" />
        </div>
      </PopperToggle>
      <PopperMenu>
        {actions.map(({ label, onClick }) => (
          <PopperMenuItem key={label} onClick={onClick}>
            {label}
          </PopperMenuItem>
        ))}
      </PopperMenu>
    </Popper>
  )
}

export default LanguageSelector
